import React, { useState } from "react";
import AdminLayout from "../layouts/AdminLayout";
import Header from "../components/course-managementt/Header";
import CoursesList from "../components/course-managementt/CoursesList";

const CourseManagement = () => {
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [priceRange, setPriceRange] = useState({ priceMin: "", priceMax: "" });

  return (
    <AdminLayout>
      <div className="font-['Roboto'] min-h-screen bg-[#D9D9D914]  px-5 md:px-5 2xl:pl-[30px] py-4 md:py-6 2xl:pr-7">
        <div className="w-full max-w-[1515px]">
          <Header
            onCategoryChange={setSelectedCategoryId}
            onStatusChange={setSelectedStatus}
            onPriceRangeChange={setPriceRange}
          />
          <CoursesList
            selectedCategoryId={selectedCategoryId}
            selectedStatus={selectedStatus}
            priceMin={priceRange.priceMin}
            priceMax={priceRange.priceMax}
          />
        </div>
      </div>
    </AdminLayout>
  );
};

export default CourseManagement;
